import {
  MSG_INPUT_SELECIONE_PERIODO,
  MSG_INPUT_SELECIONE_SETOR,
  ENUM_TIPO_RELATORIO,
  MSG_INPUT_SELECIONE_UM_ATENDENTE,
  MSG_INPUT_SELECIONE_SERVICO,
  FORMULARIOS,
} from 'utils/consts';

export const validarButtonPesquisar = (tipoRelatorio, isPerformanceGeral, isSetorial, valoresInputs) => {
  if (!valoresInputs?.dataPesquisa?.dataInicio) return MSG_INPUT_SELECIONE_PERIODO;

  if (tipoRelatorio === ENUM_TIPO_RELATORIO.STATUS) {
    return _validarRelatorioStatus(isSetorial, valoresInputs);
  }
  if (tipoRelatorio === ENUM_TIPO_RELATORIO.SOLICITACOES) {
    return _validarRelatorioSolicitacao(isSetorial, valoresInputs);
  }
  if (tipoRelatorio === ENUM_TIPO_RELATORIO.TIPO) {
    return _validarRelatorioTipo(isSetorial, valoresInputs);
  }
  if (tipoRelatorio === ENUM_TIPO_RELATORIO.ATENDIMENTOS) {
    return _validarRelatorioAtendimento(isSetorial, valoresInputs, isPerformanceGeral);
  }
};

const _validarRelatorioStatus = (isSetorial, valoresInputs) => {
  if (isSetorial && !valoresInputs?.setor) return MSG_INPUT_SELECIONE_SETOR;
  return '';
};

const _validarRelatorioSolicitacao = (isSetorial, valoresInputs) => {
  if (isSetorial && !valoresInputs?.setor) return MSG_INPUT_SELECIONE_SETOR;
  return '';
};

const _validarRelatorioTipo = (isSetorial, valoresInputs) => {
  if (valoresInputs?.assunto === FORMULARIOS.SERVICOS.id && !valoresInputs?.servico) return MSG_INPUT_SELECIONE_SERVICO;
  if (isSetorial && !valoresInputs?.setor) return MSG_INPUT_SELECIONE_SETOR;
  return '';
};

const _validarRelatorioAtendimento = (isSetorial, valoresInputs, isPerformanceGeral) => {
  if (isSetorial && !valoresInputs?.setor) return MSG_INPUT_SELECIONE_SETOR;
  if (isSetorial && !isPerformanceGeral && !valoresInputs?.atendente) return MSG_INPUT_SELECIONE_UM_ATENDENTE;
  return '';
};
